<div class="mfa">
  <div class="rpa-head">
    <h3>Resource assignments</h3>
    <button class="rpa-btn -primary" *ngIf="canManage && !loading" (click)="openAdd()">+ Assign resource</button>
  </div>

  <div class="rpa-flash -error" *ngIf="error">{{ error }} <span class="rpa-x icon-close" (click)="error=null" aria-hidden="true"></span></div>
  <div class="rpa-muted" *ngIf="loading">Loading…</div>

  <!-- list -->
  <table class="rpa-table" *ngIf="!loading && assignments.length">
    <thead>
      <tr><th>Resource</th><th class="-r">Units</th><th class="-r">Work</th><th>Booking</th><th class="-r">Cost</th><th *ngIf="canManage"></th></tr>
    </thead>
    <tbody>
      <tr *ngFor="let a of assignments">
        <td>
          <span class="rpa-res">
            <span class="rpa-avatar" [style.background]="typeColor(a.resourceType)">{{ a.initials }}</span>
            <span>
              <span class="rpa-name">{{ a.resourceName }}</span>
              <span class="rpa-over" *ngIf="a.over" title="Overallocated"><span class="icon-warning" aria-hidden="true"></span> {{ a.totalUnits }}% / {{ a.maxUnits }}%</span>
            </span>
          </span>
        </td>
        <td class="-r">{{ a.units }}%</td>
        <td class="-r">{{ a.work }}h</td>
        <td><span class="rpa-badge" [class.-proposed]="a.booking==='proposed'">{{ bookingName(a.booking) }}</span></td>
        <td class="-r rpa-mono">{{ money(a.cost, a.currency) }}</td>
        <td class="rpa-actions" *ngIf="canManage">
          <button class="rpa-icon" title="Edit" aria-label="Edit" (click)="openEdit(a)"><span class="icon-edit" aria-hidden="true"></span></button>
          <button class="rpa-icon -danger" title="Remove" aria-label="Remove" (click)="remove(a)"><span class="icon-delete" aria-hidden="true"></span></button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="rpa-empty" *ngIf="!loading && !assignments.length">
    No resources assigned yet.
    <button class="rpa-btn" *ngIf="canManage" (click)="openAdd()">Assign the first one</button>
  </div>

  <!-- dialog -->
  <div class="rpa-overlay" *ngIf="dialog">
    <div class="rpa-dialog">
      <div class="rpa-dialog-head">
        <span>{{ editId ? 'Edit assignment' : 'Assign resource' }}</span>
        <button class="rpa-icon" title="Close" aria-label="Close" (click)="closeDialog()"><span class="icon-close" aria-hidden="true"></span></button>
      </div>
      <div class="rpa-dialog-body">
        <!-- resource picker (only when adding) -->
        <div class="rpa-field" *ngIf="editId===null">
          <label>Resource *</label>
          <input class="rpa-input" placeholder="Search resources…" [(ngModel)]="pickerQuery" />
          <div class="rpa-picker">
            <ng-container *ngFor="let g of filteredGroups()">
              <div class="rpa-pick-group">{{ g.group }}</div>
              <div class="rpa-pick-item" *ngFor="let r of g.items"
                   [class.sel]="form.resourceId===r.id"
                   [class.disabled]="assignedIds.includes(r.id)"
                   (click)="pickResource(r)">
                <span class="rpa-avatar -sm" [style.background]="typeColor(r.resourceType)">{{ r.initials }}</span>
                <span class="rpa-pick-name">
                  {{ r.name }}
                  <span class="rpa-muted">{{ r.resourceType }}<span *ngIf="r.maxUnits"> · {{ r.maxUnits }}% max</span><span *ngIf="r.rate"> · {{ money(r.rate, r.currency) }}/h</span></span>
                </span>
                <span class="rpa-badge" *ngIf="assignedIds.includes(r.id)">Assigned</span>
                <span class="rpa-check" *ngIf="form.resourceId===r.id">✓</span>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="rpa-res -big" *ngIf="editId!==null && pickedRes() as r">
          <span class="rpa-avatar" [style.background]="typeColor(r.resourceType)">{{ r.initials }}</span>
          <span class="rpa-name">{{ r.name }}</span>
        </div>

        <ng-container *ngIf="form.resourceId">
          <div class="rpa-grid">
            <div class="rpa-field" *ngIf="hasUnits(pickedRes()?.resourceType)">
              <label>Allocation units</label>
              <div class="rpa-stepper">
                <button (click)="step(-1)">−</button>
                <input class="rpa-input -mono" type="number" min="0" step="5" [(ngModel)]="form.units" />
                <button (click)="step(1)">+</button>
                <span class="rpa-suffix">%</span>
              </div>
              <div class="rpa-presets">
                <span class="rpa-preset" *ngFor="let p of presets()" [class.on]="form.units===p" (click)="form.units=p">{{ p }}%</span>
              </div>
            </div>
            <div class="rpa-field">
              <label>Work (hours)</label>
              <input class="rpa-input -mono" type="number" min="0" [(ngModel)]="form.work" (ngModelChange)="onScheduleChange()" />
            </div>
            <div class="rpa-field"><label>Start</label><input class="rpa-input" type="date" [(ngModel)]="form.start" (ngModelChange)="onScheduleChange()" /></div>
            <div class="rpa-field"><label>Finish</label><input class="rpa-input" type="date" [(ngModel)]="form.finish" (ngModelChange)="onScheduleChange()" /></div>

            <div class="rpa-field">
              <label>Booking</label>
              <div class="rpa-seg">
                <button *ngFor="let b of bookings" [class.active]="form.booking===b.key" (click)="form.booking=b.key">{{ b.name }}</button>
              </div>
            </div>

            <div class="rpa-field">
              <label>Work contour</label>
              <select class="rpa-input" [(ngModel)]="form.contour" (ngModelChange)="onScheduleChange()">
                <option *ngFor="let c of contours" [value]="c.key">{{ c.name }}</option>
              </select>
            </div>
            <div class="rpa-field">
              <label>Cost rate table</label>
              <select class="rpa-input" [(ngModel)]="form.rateTable" [disabled]="!pickedRes()?.rate">
                <option *ngFor="let r of rateTables" [value]="r.key">{{ r.name }}</option>
              </select>
            </div>
          </div>

          <!-- ── timephased work grid (day-by-day distribution) ── -->
          <div class="rpa-tp" *ngIf="hasUnits(pickedRes()?.resourceType) && form.timephased.length">
            <div class="rpa-tp-head">
              <span class="rpa-tp-title">Timephased work</span>
              <span class="rpa-tp-sub" *ngIf="!form.timephasedManual">Auto from contour · {{ tpTotal() | number:'1.0-2' }}h across {{ form.timephased.length }} working days</span>
              <span class="rpa-tp-sub -manual" *ngIf="form.timephasedManual">Manually edited · {{ tpTotal() | number:'1.0-2' }}h total</span>
              <span class="rpa-spacer"></span>
              <button class="rpa-btn -tiny" type="button" *ngIf="form.timephasedManual" (click)="resetContour()">Reset to contour</button>
            </div>
            <div class="rpa-tp-grid">
              <div class="rpa-tp-cell" *ngFor="let p of form.timephased; let i = index">
                <div class="rpa-tp-day">{{ tpWeekday(p.date) }} {{ tpDayNum(p.date) }}</div>
                <input class="rpa-tp-input" type="number" min="0" step="0.5"
                       [ngModel]="p.hours" (ngModelChange)="editCell(i, $event)" [name]="'tp'+i" />
              </div>
            </div>
            <div class="rpa-tp-hint">Edit a cell to set a custom (manual) contour — MS Project style. Weekends and holidays carry no work.</div>
          </div>

          <div class="rpa-warn" *ngIf="liveAlloc() as al" [hidden]="!al.over">
            <span class="icon-warning" aria-hidden="true"></span> <b>{{ pickedRes()?.name }}</b> would be allocated <b>{{ al.total }}%</b> vs a {{ al.max }}% max
            ({{ al.elsewhere }}% booked elsewhere) — over by {{ al.total - al.max }}%.
          </div>

          <div class="rpa-cost" *ngIf="liveCost() as c">
            <div>
              <div class="rpa-cost-k">Estimated cost</div>
              <div class="rpa-muted">
                <span *ngIf="c.rate">{{ tpTotal() || form.work }}h × {{ money(c.rate, c.cur) }}/h<span *ngIf="c.usesTable"> (table {{ form.rateTable }})</span></span>
                <span *ngIf="!c.rate">No hourly rate</span>
              </div>
            </div>
            <div class="rpa-cost-v">{{ money(c.cost, c.cur) }}</div>
          </div>
        </ng-container>
      </div>
      <div class="rpa-dialog-foot">
        <button class="rpa-btn -primary" [disabled]="!form.resourceId" (click)="save()">{{ editId ? 'Save' : 'Assign' }}</button>
        <button class="rpa-btn" (click)="closeDialog()">Cancel</button>
      </div>
    </div>
  </div>
</div>
